var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _toArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toArray");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _ = require('lodash');

var flatten = require('flat');

var FLATTEN_CONFIG = {
  delimiter: '-',
  maxDepth: 2
};

var getName = function getName(name) {
  return name.split('-default').join('');
};

module.exports = function () {
  return function (_ref) {
    var addUtilities = _ref.addUtilities,
        addComponents = _ref.addComponents,
        addBase = _ref.addBase,
        addVariant = _ref.addVariant,
        e = _ref.e,
        prefix = _ref.prefix,
        theme = _ref.theme,
        variants = _ref.variants,
        config = _ref.config;

    var buildConfig = function buildConfig(themeKey) {
      for (var _len = arguments.length, fallbackKeys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fallbackKeys[_key - 1] = arguments[_key];
      }

      return buildConfigFromTheme.apply(void 0, [themeKey].concat(fallbackKeys)) || buildConfigFromArray(themeKey);
    };

    var buildConfigFromTheme = function buildConfigFromTheme(themeKey) {
      var buildObject = function buildObject(_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            modifier = _ref3[0],
            value = _ref3[1];

        return [modifier, _defineProperty({}, themeKey, value)];
      };

      var getThemeSettings = function getThemeSettings(themeKey, fallbackKeys) {
        var _ref5 = fallbackKeys || [],
            _ref6 = _toArray(_ref5),
            newThemeKey = _ref6[0],
            newFallbackKeys = _ref6.slice(1);

        return theme(themeKey, false) || fallbackKeys.length && getThemeSettings(newThemeKey, _toConsumableArray(newFallbackKeys));
      };

      for (var _len2 = arguments.length, fallbackKeys = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        fallbackKeys[_key2 - 1] = arguments[_key2];
      }

      var themeSettings = getThemeSettings(themeKey, fallbackKeys);
      var themeObject = _.isArray(themeSettings) ? _.zipObject(themeSettings, themeSettings) : themeSettings;
      var themeEntries = themeSettings && Object.entries(flatten(themeObject, FLATTEN_CONFIG)).map(function (entry) {
        return buildObject(entry);
      });
      return themeSettings ? _.fromPairs(themeEntries) : false;
    };

    var buildConfigFromArray = function buildConfigFromArray(property) {
      var defaultSettings = defaultValues[property];
      var defaultEntries = defaultSettings && defaultSettings.map(function (value) {
        return [value, _defineProperty({}, property, value)];
      });
      return defaultSettings ? _.fromPairs(defaultEntries) : false;
    };

    var defaultValues = {
      columnCount: [1, 2, 3],
      columnRuleStyle: ['none', 'hidden', 'dotted', 'dashed', 'solid', 'double', 'groove', 'ridge', 'inset', 'outset'],
      columnFill: ['auto', 'balance', 'balance-all'],
      columnSpan: ['none', 'all']
    };
    var pluginUtilities = {
      'col-count': buildConfig('columnCount'),
      'col-gap': buildConfig('columnGap', 'gap', 'gridGap'),
      'col-w': buildConfig('columnWidth'),
      'col-rule-color': buildConfig('columnRuleColor', 'borderColor'),
      'col-rule-width': buildConfig('columnRuleWidth', 'borderWidth'),
      'col-rule-style': buildConfig('columnRuleStyle'),
      'col-fill': buildConfig('columnFill'),
      'col-span': buildConfig('columnSpan')
    };
    Object.entries(pluginUtilities).filter(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
          modifier = _ref9[0],
          values = _ref9[1];

      return !_.isEmpty(values);
    }).forEach(function (_ref10) {
      var _ref11 = _slicedToArray(_ref10, 2),
          modifier = _ref11[0],
          values = _ref11[1];

      var className = _.kebabCase(modifier).split('-').slice(0, 2).join('-');

      var variantName = Object.keys(Object.entries(values)[0][1])[0];

      var escapedValues = _.fromPairs(Object.entries(values).map(function (_ref12) {
        var _ref13 = _slicedToArray(_ref12, 2),
            modifier = _ref13[0],
            value = _ref13[1];

        return [e(modifier), value];
      }));

      var utilities = flatten(_defineProperty({}, ".".concat(e("".concat(className))), escapedValues), FLATTEN_CONFIG);
      addUtilities(_.mapKeys(utilities, function (value, key) {
        return getName(key);
      }), variants(variantName, ['responsive']));
    });
  };
};